import { render } from "./EditReminder.vue?vue&type=template&id=d258abe4&scoped=true&ts=true"
import script from "./EditReminder.vue?vue&type=script&lang=ts"
export * from "./EditReminder.vue?vue&type=script&lang=ts"

import "./EditReminder.vue?vue&type=style&index=0&id=d258abe4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d258abe4"]])

export default __exports__